module.exports = __webpack_public_path__ + "img/coopimg.f01e5b0b.png";